export const defaultClientConfig = {
    // SITE BRANDING & LAYOUT
    siteTitle: "",
    footerText: "",
    useSimpleLayout: false,
    currencyFormat: "AUD",
    currencyLocale: "EN-AU",
    logoImageUri: "", //OBSOLETE
    logoSecondaryImageUri: "", //OBSOLETE
    logoImageLightUri: "",
    logoImageDarkUri: "",
    logoImageVariantUri: "",
    heroImageUri: "",
    bankCardActiveUri: "",
    bankCardInActiveUri: "",
    loginScreenLayout: "",
    logoWidth: 0,
    logoWidthMobile: 0,
    logoHeight: 0,
    logoHeightMobile: 0,
    navbarTextColor: "#fff",
    // HELP & SUPPORT
    showClientVersion: true,
    showTermsAndConditions: false,
    showPrivacyPolicy: false,
    supportEmailAddress: "",
    supportPhoneNumber: "",
    linkToPrivacyPolicy: "",
    linkToTermsAndConditions: "",
    showPdfPrivacyPolicy: false,
    showPdfTermsAndConditions: false,
    // LOGIN SCREEN
    loginWelcomeMessage: "Welcome to Fortis. Our online solution to support your business goals.",
    forgotUsernamePageTitle: "",
    forgotUsernamePageCopy: "",
    forgotPasswordPageTitle: "",
    forgotPasswordPageCopy: "",
    // LOGIN SCREEN - RESET PASSWORD
    allowOnlinePasswordReset: false,
    loginResetPasswordText: "Reset Password",
    // NAVIGATION
    transferMenuText: "Transfer", //OBSOLETE
    // USER PROFILE
    hideLastLoginIp: false,
    // AUTHENTICATOR / 2FA
    _productLabel: "",
    _issuer: "",
    loginAuthenticatorMessage: "Confirm your login by entering the authorisation code provided by your preferred one-time password application.",
    manageAuthenticatorMessage: "To manage your authentication settings, please enter the authorisation code provided by your preferred one-time password application.",
    loginSecurityTokenMessage: "Confirm your login by entering the security token that you will receive shortly.",
    manageSecurityTokenMessage: "To begin setting up an authenticator app, enter the security token that you will receive shortly.",
    // MY FINANCES / ACCOUNTS
    myFinancesTitle: "My Finances",
    showUserInWelcomeMessage: false,
    showInstrumentTitle: true,
    maturesMetricLabel: "Matures",
    showAccountTitle: true,
    minimumInstalmentLabel: "Min monthly instalment",
    showAvailableRedraw: true,
    arrearsMessage: "",
    accountAvailableLabel: "Available",
    showPrimaryBorrowerName: false,
    showAccountCurrentRate: false,
    numberOfAccountsToDisplayOnDashboard: 5,
    canViewArrearsAmount: false,
    redirectToSingleInstrument: false,
    showRemainingDisbursementAmount: false,
    showBpayDetails: false,
    hideInstalmentDetails: false,
    showAccountDisbursementPageButton: false,
    allowTransactionExport: false,
    // TRANSFERS
    hideTransferPage: false,
    bankingCutOffWarning: "",
    fundsTransferDescriptionRequired: false,
    futureDatedTransferWarning: "Future-dated transfers require cleared funds in your account on the day before the scheduled transfer date or your transfer will be unsuccessful.",
    transferCardsSubText: "",
    allowDisbursements: false,
    disbursementFileText: "",
    showManageBPAYBillers: true,
    BPAYWarningMessage: "",
    useRealtimePaymentDefaultedOn: false,
    realtimePaymentTooltipText: "Choosing Realtime payment will allow for a single payment to be processed immediately",
    // STATEMENTS
    allowOnLineStatements: false,
    // CARDS
    hideCardPage: true,
    // TRANSACTIONS
    transactionHistoryLimitDays: 90,
    transactionPageSize: 20,
    showIconsTransactionPage: false,
    BETA_showDetailView: true,
    showTransactionsAsLender: true,
    // PROFILE SETTINGS
    showProfilePersonalInformation: true,
    showProfileAddresses: true,
    showProfilePreferredMethodOfCorrespondence: true,
    // SECURE MESSAGING
    displaySecureMessagePage: true,
    //DOCUMENTS PAGE
    displayDocumentsPage: false,
    // INFRASTRUCTURE
    deviceAssetsBaseUri: undefined,
    capitalApiBaseUri: process.env.FORTIS_CAPITAL_API_BASEURI,
};
const clientConfigFn = () => {
    const windowConfig = 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window && window.__INTERFI__;
    return {
        ...defaultClientConfig,
        ...windowConfig, //overrides from live site
    };
};
export { clientConfigFn };
